import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from '@/types/utils';

export class IDriver {
  blood_type: string;
  id: string | number;
  identity_number: string;
  userId: string | number;
}

export class IDriverResponse {
  @Type(() => IDriver)
  result: IDriver;
}

export class IDriverListResponse extends IPagination {
  @Type(() => IDriver)
  results: IDriver[];
}

export class IDriverQueryDto extends IQueryPaginationDto {
  name?: string;
}

export class ICreateDriverDto {
  userId: number;
  bloodType: string;
  identityNumber: string;
}
